export const RoutePaths = {
  PAGE_NOT_FOUND: "/",
  VIEWPORT: "/:orgName/:projectName",  
}